import { ISalesDocument } from '@cemex-core/cmx-api';
import { ISalesDocument as InvoiceSalesDocument } from '@cemex-core/cmx-api/models/sales-document-management';
import { OneClickContractActions, OneClickContractActionTypes } from '../actions/one-click-contract.actions';
import { OneClickProfileActions, OneClickProfileActionTypes } from '../actions/one-click-profile.actions';
import { OneClickContractType } from '../models/one-click-contract.model';

export interface OneClickContractsState {
  loading: boolean[];
  contractsAvailable: ISalesDocument[][];
  selected: ISalesDocument[];
  invoicesAvailable: InvoiceSalesDocument[][];
  invoiceSelected: InvoiceSalesDocument[];
  contractTypeSelected: OneClickContractType[];
}

export const initialState: OneClickContractsState = {
  loading: [],
  contractsAvailable: [],
  selected: [],
  invoicesAvailable: [],
  invoiceSelected: [],
  contractTypeSelected: [],
};

export function reducer(
  state = initialState,
  action: OneClickContractActions | OneClickProfileActions,
): OneClickContractsState {
  switch (action.type) {
    case OneClickContractActionTypes.LOAD_CONTRACTS: {
      state.loading[action.index] = true;
      return {
        ...state,
        loading: state.loading.map((item, index) => {
          if (index === action.index) {
            return true;
          } else {
            return item;
          }
        }),
      } as OneClickContractsState;
    }
    case OneClickContractActionTypes.LOAD_CONTRACTS_COMPLETE: {
      state.loading[action.index] = true;
      state.contractsAvailable[action.index] = undefined;
      return {
        ...state,
        loading: state.loading.map((item, index) => {
          if (index === action.index) {
            return false;
          } else {
            return item;
          }
        }),
        contractsAvailable: state.contractsAvailable.map((item, index) => {
          if (index === action.index) {
            return [...action.payload];
          } else {
            return item;
          }
        }),
      } as OneClickContractsState;
    }
    case OneClickContractActionTypes.SELECT_CONTRACT: {
      state.selected[action.index] = undefined;
      return {
        ...state,
        selected: state.selected.map((item, index) => {
          if (index === action.index) {
            return action.payload;
          } else {
            return item;
          }
        }),
      } as OneClickContractsState;
    }
    case OneClickContractActionTypes.SELECT_CONTRACT_TYPE: {
      state.contractTypeSelected[action.index] = undefined;
      return {
        ...state,
        contractTypeSelected: state.contractTypeSelected.map((item, index) => {
          if (index === action.index) {
            return action.payload;
          } else {
            return item;
          }
        }),
      } as OneClickContractsState;
    }
    case OneClickContractActionTypes.LOAD_INVOICES_COMPLETE: {
      state.loading[action.index] = true;
      state.invoicesAvailable[action.index] = undefined;
      return {
        ...state,
        loading: state.loading.map((item, index) => {
          if (index === action.index) {
            return false;
          } else {
            return item;
          }
        }),
        invoicesAvailable: state.invoicesAvailable.map((item, index) => {
          if (index === action.index) {
            return [...action.payload];
          } else {
            return item;
          }
        }),
      } as OneClickContractsState;
    }
    case OneClickContractActionTypes.SELECT_INVOICE: {
      state.invoiceSelected[action.index] = undefined;
      return {
        ...state,
        invoiceSelected: state.invoiceSelected.map((item, index) => {
          if (index === action.index) {
            return action.payload;
          } else {
            return item;
          }
        }),
      } as OneClickContractsState;
    }
    case OneClickProfileActionTypes.RESET_BUILDER:
    case OneClickContractActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
